module.exports = __webpack_public_path__ + "static/surya-logo-s-black-94d5df15505676b1743cd7cf543f1ab7.png";